export const CoreMessages = {
  StartApp: 'START_APP',
  SignupHandshakeComplete: 'SIGNUP_HANDSHAKE_COMPLETE',
  HandshakeReceive: 'INTEGRATED_APP_EMBEDDER_HANDSHAKE_RECEIVED',
  SendRefreshToken: 'INTEGRATED_APP_EMBEDDER_SEND_REFRESH_TOKEN',
  ReloadParentFrame: 'INTEGRATED_APP_EMBEDDER_RELOAD_PARENT_FRAME',
  RedirectParentFrame: 'INTEGRATED_APP_EMBEDDER_REDIRECT_PARENT_FRAME',
  SendLocale: 'INTEGRATED_APP_EMBEDDER_SEND_LOCALE',
  SendDeviceId: 'INTEGRATED_APP_EMBEDDER_SEND_DEVICE_ID',
  SendIntegratedAppConfig: 'INTEGRATED_APP_EMBEDDER_CONFIG',
  ConnectIntegration: 'INTEGRATED_APP_EMBEDDER_CONNECT_INTEGRATION',
  ConnectIntegrationResponse: 'INTEGRATED_APP_EMBEDDER_CONNECT_INTEGRATION_RESPONSE',
  ConnectIntegrationError: 'INTEGRATED_APP_EMBEDDER_CONNECT_INTEGRATION_ERROR',
  SignalAppNavigation: 'INTEGRATED_APP_EMBEDDER_SIGNAL_APP_NAVIGATION',
  ResetIntegrationRequest: 'INTEGRATED_APP_EMBEDDER_RESET_INTEGRATION_REQUEST',
  ResetIntegrationResponse: 'INTEGRATED_APP_EMBEDDER_RESET_INTEGRATION_RESPONSE',
  ResetIntegrationError: 'INTEGRATED_APP_EMBEDDER_RESET_INTEGRATION_ERROR'
};